import { cn } from "../../lib/utils";

export const BrutalButton = ({
  children,
  variant = "primary",
  className = "",
  ...props
}) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-5 py-3 text-sm font-bold uppercase tracking-wider border-2 border-[#3D1E6D] transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary:
      "bg-[#E5247C] text-white shadow-[4px_4px_0_#3D1E6D] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#3D1E6D]",
    secondary:
      "bg-[#FFB400] text-[#3D1E6D] shadow-[4px_4px_0_#3D1E6D] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#3D1E6D]",
    outline:
      "bg-white text-[#3D1E6D] hover:bg-[#FFF4E6] shadow-[4px_4px_0_#3D1E6D] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#3D1E6D]",
    dark: "bg-[#3D1E6D] text-white shadow-[4px_4px_0_#E5247C] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#E5247C]",
    ghost:
      "bg-transparent text-[#3D1E6D] border-transparent hover:bg-[#FFF4E6] shadow-none",
  };
  return (
    <button
      className={cn(base, variants[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
};

export const BrutalCard = ({ children, className = "", hover = false, ...props }) => (
  <div
    className={cn(
      "bg-white border-2 border-[#3D1E6D] shadow-[4px_4px_0_#3D1E6D]",
      hover && "transition-transform duration-150 hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#3D1E6D]",
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export const BrutalInput = ({ className = "", ...props }) => (
  <input
    className={cn(
      "w-full bg-white border-2 border-[#3D1E6D] px-3 py-2.5 text-base font-medium text-[#3D1E6D] placeholder:text-[#6B4E9E]/60 focus:outline-none focus:border-[#E5247C] focus:shadow-[2px_2px_0_#E5247C] transition-all",
      className
    )}
    {...props}
  />
);

export const BrutalTextarea = ({ className = "", ...props }) => (
  <textarea
    className={cn(
      "w-full bg-white border-2 border-[#3D1E6D] px-3 py-2.5 text-base font-medium text-[#3D1E6D] placeholder:text-[#6B4E9E]/60 focus:outline-none focus:border-[#E5247C] focus:shadow-[2px_2px_0_#E5247C] transition-all min-h-[100px]",
      className
    )}
    {...props}
  />
);

export const BrutalLabel = ({ children, className = "" }) => (
  <label
    className={cn(
      "block text-xs font-bold tracking-[0.2em] uppercase text-[#6B4E9E] mb-1.5",
      className
    )}
  >
    {children}
  </label>
);

export const Badge = ({ children, color = "yellow", className = "" }) => {
  const colors = {
    yellow: "bg-[#FFB400] text-[#3D1E6D]",
    orange: "bg-[#FF8C42] text-[#3D1E6D]",
    magenta: "bg-[#E5247C] text-white",
    purple: "bg-[#5B2B82] text-white",
    teal: "bg-[#00B5C4] text-[#3D1E6D]",
    dark: "bg-[#3D1E6D] text-white",
    green: "bg-[#10B981] text-white",
    red: "bg-[#EF4444] text-white",
    amber: "bg-[#F59E0B] text-white",
    white: "bg-white text-[#3D1E6D]",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border-2 border-[#3D1E6D]",
        colors[color],
        className
      )}
    >
      {children}
    </span>
  );
};

export const SectionTitle = ({ kicker, title, className = "" }) => (
  <div className={cn("space-y-1", className)}>
    {kicker && (
      <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#E5247C]">
        {kicker}
      </div>
    )}
    <h2 className="display text-3xl sm:text-4xl text-[#3D1E6D] leading-none">
      {title}
    </h2>
  </div>
);
